import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {ProductsPageActionBttns} from '../../../ui/setup/products/products-page-action-bttns';
import {ProductsWrapper} from '../../../ui/setup/products/products-wrapper';

export function ProductsPageStandalone() {
    setBodyId('list-product');

    return (
        <PageContainer
            title='Products'
            pageTitleBar={
                <PageTitleBar
                    title='Products'
                    subheaderPrimaryText='Track products sold, with separate pricing per market.'
                    buttons={<ProductsPageActionBttns />}
                />
            }
            whiteBackground={true}
        >
            <ProductsWrapper />
        </PageContainer>
    );
}
